(function () {
  // 指定のセレクタが現れるまで監視する関数
  function waitForElement(selector, callback, timeout = 5000) {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(interval);
        callback(el);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(interval);
        console.warn("要素が見つかりませんでした:", selector);
      }
    }, 100);
  }

  // メイン処理：フォーム表示後に書き換え
  function applyFormChanges() {
    // 「表示名」→「氏名」
    const label = document.querySelector("label[for^='jdgm_review_reviewer_name_']");
    if (label) label.textContent = "氏名(非公開となります)";

    // 「のように公開表示」→「氏名は非公開となります」
    const note = document.querySelector("label[for^='jdgm_review_reviewer_name_format_']");
    if (note) note.textContent = "氏名は非公開となります";

    // inputの placeholder と aria-label を更新
    const input = document.querySelector("input[name='reviewer_name']");
    if (input) {
      input.placeholder = "氏名";
      input.setAttribute("aria-label", "氏名");
    }

    // 「あなたのデータの使用方法：〜」の文言を書き換え
    // 文章の入った<p>タグを探す（テキストの一部で判別）
    const paragraphs = document.querySelectorAll(".jdgm-form__fieldset p");
    paragraphs.forEach(p => {
      if (p.textContent.includes("あなたのデータの使用方法")) {
        p.textContent = "ご記入いただいたレビューは、サービス向上の目的にのみ利用させていただきます。ご連絡が必要な場合に限り、登録されたメールアドレスにご連絡を差し上げることがございます。同意の上でご投稿ください。";
      }
    });
  }

  // Judge.me のフォームが出るまで待機して処理実行
  waitForElement("form.jdgm-form", () => {
    setTimeout(applyFormChanges, 300);
  });
})();
